import React from 'react';
import CommonPage from './CommonPage';

const AboutUs = () => {
  return (
    <CommonPage title="আমাদের সম্পর্কে">
      আমরা একটি অনলাইন বইয়ের দোকান, যেখানে আপনি পাবেন আপনার পছন্দের সকল ধরনের বই।
    </CommonPage>
  );
};

export default AboutUs;
